export class UserProfile {
  UserId: string;
  FirstName: string;
  LastName: string;
  Company: any;
  Email: string;
}
